<template>
  <div class="loader" :style="`font-size: ${size}px`">{{ $t('ui.spinner_loading') }}</div>
</template>

<script setup>
defineProps({
  size: {
    type: Number,
    default: 10,
  },
});
</script>

<style scoped lang='scss'>
.loader,
.loader:after {
  border-radius: 50%;
  width: 10em;
  height: 10em;
}
.loader {
  margin-top: 0;
  margin-bottom: 0;
  position: relative;
  text-indent: -50px;
  overflow: hidden;
  border-top: 1.1em solid var(--skeleton-sheen);
  border-right: 1.1em solid var(--skeleton-sheen);
  border-bottom: 1.1em solid var(--skeleton-sheen);
  border-left: 1.1em solid var(--text);
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 1.1s infinite linear;
}
@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
